import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import Alert from '../alerts/Alert/Alert';
import AlertDanger from '../alerts/AlertDanger/AlertDanger';
import Avatar from '../Avatar/Avatar';
import BookingListItemActions from '../BookingListItemActions/BookingListItemActions';
import TeacherInformation from '../TeacherInformation/TeacherInformation';

import './BookingListItem.css';

class BookingListItem extends Component {
  static get propTypes() {
    return { booking: PropTypes.object.isRequired };
  }

  constructor(props) {
    super(props);

    const startDateTime = moment(this.props.booking.startTime);
    const endDateTime = startDateTime.clone().add(this.props.booking.duration, 'minutes');

    this.state = { startDateTime, endDateTime };
  }

  renderError(error) {
    return <AlertDanger className="BookingListItem" error={error} />;
  }

  renderAlert(error) {
    return (
      <Alert className="CancellationNotice mb-3" alertType="warning">
        <h5>Warning: We are unable to process your request at this time.</h5>
        <p>
          {error.message}
        </p>
      </Alert>
    );
  }

  render() {
    const { booking } = this.props;
    const { teacher } = booking;

    const teacherAvatarUrl = teacher.imageUrl;
    const teacherName = teacher.givenName;
    const serviceName = booking.service.description;

    const { reservationsError } = this.props;

    return (
      <div className="BookingListItem card">
        <div className="card-header bg-primary">
          <h5 className="mb-0 text-white">{serviceName}</h5>
        </div>

        <div className="card-block d-flex flex-column">
          {// if a cancellation or reschedule error occurs and
          // the bookingId matches this booking's id,
          // render an alert message on the card
          (this.props.reservationsStatus === 'cancellation_error' ||
            this.props.reservationsStatus === 'reschedule_error') &&
            reservationsError &&
            reservationsError.bookingId === booking.id &&
            this.renderAlert(reservationsError)
          }

          <div className="row flex-column flex-md-row flex-nowrap">
            <div className="col-12 col-md col-lg-3 align-self-center text-center mb-2">
              <Avatar
                className="d-inline-block"
                imageClassName="avatar"
                src={teacherAvatarUrl}
                alt={teacherName}
              />
            </div>

            <TeacherInformation
              className="col-12 col-md-5 col-lg-5 mb-2 mr-auto"
              teacher={teacher}
              hideRatings={true}
              hideDescription={false}
              hideBadge
              linkTeacherPage
            />

            <div className="booking-information col-12 col-md-5 col-lg-4 text-center text-md-left mb-2 mt-2 mt-md-0">
              <h4> Date and Time </h4>
              <p>
                {this.state.startDateTime.format('dddd, MMMM Do YYYY')}
                <br />
                from
                {' '}
                {this.state.startDateTime.format('LT')}
                {' '}
                to
                {' '}
                {this.state.endDateTime.format('LT')}
                {/* UTC{this.state.startDateTime.format('ZZ')} */}
              </p>
            </div>
          </div>

          <BookingListItemActions
            startDateTime={this.state.startDateTime.clone()}
            endDateTime={this.state.endDateTime.clone()}
            teacher={teacher}
            booking={booking}
            serviceName={serviceName}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    reservationsStatus: state.reservations.status,
    reservationsError: state.reservations.error
  };
}

export default connect(mapStateToProps)(BookingListItem);



// WEBPACK FOOTER //
// ./src/components/BookingListItem/BookingListItem.js